/*
 * Copyright (c) Nexign, JSC, 2021.
 */
/**
 *
 *
 * @author Yakov Gushchin
 * @version 1.15.0
 * @since 1.15.0
 */

import { EBreadCrumbType } from '../../modules/breadCrumbs/breadCrumbsTypes';
import { IAppRouterConfiguration } from '../appRouterTypes';
import { RoutePath } from './routesConstants';

export const PaymentsRouteConfiguration: IAppRouterConfiguration[] = [
    {
        path: RoutePath.paymentsAccount,
        breadCrumbs: [EBreadCrumbType.accounts, EBreadCrumbType.payments],
    },
    {
        path: RoutePath.paymentsAccountId,
        breadCrumbs: [EBreadCrumbType.accounts, EBreadCrumbType.accountId, EBreadCrumbType.paymentsAccountId],
    },
];
